import { useTranslation } from 'react-i18next';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  label?: string;
}

export default function LoadingSpinner({ size = 'medium', label }: LoadingSpinnerProps) {
  const { t } = useTranslation();

  return (
    <div className={`loading-state loading-state--${size}`}>
      <div className={`loading-spinner loading-spinner--${size}`} />
      {label !== '' && (
        <p className="loading-label">{label ?? t('common.loading')}</p>
      )}
    </div>
  );
}
